const interfacePhrases = {
    rate_limited: '频率受限',
    limit_exceeded: '超出限额',
    used: '使用',
    identifier: '标识',
    verification: '验证',
    messages: '消息',
    data: '数据',
    custom: '自定义',
    management_api: '{{product}} 管理接口',
    management_api_role_description: '此内置角色授予管理接口的访问权限。',
    client_credentials: '客户端凭据',
    authentication_request: '身份验证请求',
    callback: '身份验证回调',
    help_title: 'iden帮助中心',
    help_subtitle: '无需离开当前页面即可查看帮助',
    open_help: '打开完整帮助页面',
    close_help: '关闭帮助',
    about: '关于与开源声明',
    open_navigation: '打开导航',
    close_navigation: '关闭导航',
    development_enabled: '已启用开发功能',
    beta: '测试版',
    impersonation: '身份模拟',
    key: '键',
    value: '值',
    error: '错误',
    details: '技术详情',
    callback_failed: '无法完成登录回调。',
    back_sign_in: '返回登录',
    powered_by: '技术支持：',
    avatar: '头像',
    logo: '标志',
    qr_code: '二维码',
    sample_title: '想查看示例吗？',
    sample_description: '查看使用本指南的示例应用。',
    sample_action: '查看示例',
    further_readings: '延伸阅读',
    complete_guide: '完整指南',
    custom_domains_notice: '添加<a>自定义域名</a>后，可以使用以下端点：<code>{{endpoint}}</code>。',
    my_project: '我的项目',
    my_secret: '我的密钥',
    my_token: '我的令牌',
    role_example: '查看者',
    reset_retry: '重置配置并重试',
    open_dev_panel: '打开开发者面板',
    close_dev_panel: '关闭开发者面板',
    configuration: '配置',
    app_id: '应用标识',
    extra_parameters: '附加登录参数',
    prompt: '身份验证提示',
    scope: '作用域',
    resource: '资源',
    resources_space_delimited: '资源（以空格分隔）',
    sign_out_to_apply: '退出登录后即可应用更改。',
    refresh_token_grant: '刷新令牌授权',
    organization_id: '组织标识',
    console_result: '请在浏览器控制台查看结果。',
    request_token: '请求令牌',
    user_info: '用户信息',
    get_id_token_claims: '获取身份令牌声明',
    fetch_user_info: '获取用户信息',
    device_initializing: '正在初始化设备授权…',
    device_success: '你已成功登录演示应用。',
    sign_in_information: '你的登录信息：',
    email: '邮箱',
    username: '用户名',
    user_id: '用户标识',
    sign_out_demo: '退出演示应用',
    device_expired: '设备验证码已过期',
    generic_error: '出现错误',
    device_expired_description: '设备验证码已过期，请重试以获取新验证码。',
    sign_in_title: '登录你的账户',
    scan_instruction: '扫描二维码，或在其他设备上打开以下地址：',
    one_time_code: '输入一次性验证码',
    token_info: '令牌信息',
    get_access_token: '获取访问令牌',
    context_unavailable: '无法加载账户信息。',
    not_initialized: '账户信息尚未初始化。',
    not_set: '未设置',
    configured: '已配置',
    password: '密码',
    phone: '手机号',
    search_help: '搜索帮助',
    language: '语言',
    menu: '菜单',
    compatibility_notice: '兼容性说明：继承自Logto的开发工具包、软件包、协议、组件和请求头名称保持不变。',
    source: '来源',
    upstream_repository: '上游仓库',
    current_fork: '当前仓库',
    license_notice: 'iden基于Logto构建；Logto是按Mozilla公共许可证 2.0 授权的开源软件。',
    about_description: '产品信息与开源声明。',
    page_not_found: '页面未找到',
    page_not_found_description: '此页面不可用，请返回帮助中心继续浏览。',
    introduction: '简介',
    quick_starts: '快速入门',
    integration: '集成',
    end_user_flows: '最终用户流程',
    authorization: '授权',
    user_management: '用户管理',
    security: '安全',
    customization: '自定义',
    connectors: '连接器',
    organizations: '组织',
    self_hosting: '自托管',
    continue: '继续',
    loading: '加载中…',
    save: '保存',
    saved: '已保存',
    try_again: '重试',
    client_id: '客户端标识',
    client_secret: '客户端密钥',
    redirect_uri: '重定向地址',
    status: '状态',
    type: '类型',
    permissions: '权限',
    token_data: '令牌数据',
    context_data: '上下文数据',
    jwt_extra_claims: '附加令牌声明',
    action_result: '操作结果',
    social_account_already_linked: '此社交账号已关联。',
};
export default Object.freeze(interfacePhrases);
